import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AlertService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { ButtonItem } from '../../../button/button.model';
import { LoaderEnabled } from '../../../components/loader/loader.service';
import { PropertyChangeEvent } from '../../../models/property-change-event';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { PageDefinition } from '../../../search/models/page-definition.model';
import { SearchEvent } from '../../../search/models/search-event';
import { Clause, Condition, SearchCriteria } from '../../../search/models/search-filter-model';
import { SearchParams } from '../../../search/models/search-params.model';
import { SearchStatus } from '../../../search/models/search-status.model';
import { NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT, REFRESH_SEARCH_EVENT } from '../../../search/search-constants';
import { SearchService } from '../../../search/search.service';
import { SearchableEntityDataEditorService } from '../../../services/searchable-entity/searchable-entity-data-editor.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';

@Component({
  selector: 'lfwms-assign-vehicle-popup',
  templateUrl: './assign-vehicle-popup.component.html',
  styleUrls: ['./assign-vehicle-popup.component.css']
})
export class AssignVehiclePopupComponent {

  public assignVehicleSearchService: SearchService;
  public showTable: boolean = true;
  public primaryKey: string = '';
  public primarKeyValue: string = '';
  public maxIdValueForAssignVehicleTable: any;
  public dropDownKeyValueMap: any = {};
  public tableMode = 'V'; // Should be bound from template and changed as per button action
  public buttonPanelButtonArray = [
    new ButtonItem('Edit', this.coreServiceRegistry.resourceService.get('btn_edit'), 'assgn_veh_edit', 'icon_edit.svg', []),
    new ButtonItem('Delete With Privilege', this.coreServiceRegistry.resourceService.get('btn_delete'), 'assgn_veh_del', 'icon_delete.svg', []),
    new ButtonItem('Add Row', this.coreServiceRegistry.resourceService.get('lbl_AddNewRow'), 'assgn_veh_add', 'icon_edit.svg', []),
    new ButtonItem('Save', this.coreServiceRegistry.resourceService.get('btn_save'), '', 'icon_save.svg', []),
  ];



  private http$ = this.coreServiceRegistry.http$;
  private resourceService = this.coreServiceRegistry.resourceService;

  constructor(
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry,
    private alertService: AlertService
  ) { }

  public initializeComponents(primaryKeyName: string, primaryKeyValue: string) {
    // initialize button sbased on table mode
    this.refreshButtons();
    // initialize the table and search context */
    // const testValue = primaryKeyName === 'loadKey' ? '0000071086' : '0000058989';
    this.primaryKey = primaryKeyName;
    this.primarKeyValue = primaryKeyValue;
    this.initializeAssignVehicleSearchContext(primaryKeyName, primaryKeyValue);
  }

  public initializeAssignVehicleSearchContext(keyColName: string, columnValue: string) {

    const tabledId = keyColName === 'loadKey' ? 'ASSIGNLOADVEHTD' : 'ASSIGNMBOLVEHTD';
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = tabledId;
    searchParams.isFullFetch = true;
    /* Data editor
     ** DataTableEditorService -- is needed  for tableheader filter to work. use in readonly tables.
     Filter might misbehave if datatype is not set properly in metdata from db.
     ** SearchableEntityDataEditorService --  reqd for table editing - propvaluechanged method etc..*/
    searchParams.tableEditor = new SearchableEntityDataEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    searchParams.paginateLocally = false;
    // LFWM-3191-fix to load buttons by privilege in popups.
    searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.buttonPanelButtonArray);
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.editable = true; // To allow table edits.ELse always in view mode
    //  tableConfig.isColumnEditable = this.isColumnEditable ; // method can be overridden if needed
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;  // hide filter input boxes in header
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.assignVehicleSearchService = this.sharedServiceRegistry.createSearchService(searchParams,
      searchStatus);

    this.assignVehicleSearchService.fetchMetadata()
      .subscribe(data => {
        this.getDropdownValuesToPopulate().subscribe((response) => {
          this.dropDownKeyValueMap = response['vehicleKeys'];
          this._getAssignVehicleTableData(keyColName, columnValue);
        });
      });

  }

  private _getAssignVehicleTableData(keyColName: string, columnValue: string) {

    this.assignVehicleSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    const searchCriteria = new SearchCriteria();
    const searchCondition = new Condition();
    searchCondition.isMandatory = false;
    const defaultClause = new Clause();
    defaultClause.operation = '=';
    defaultClause.column = keyColName;
    defaultClause.value = columnValue;
    searchCondition.clauses = [defaultClause];
    searchCondition.operator = 'AND';
    searchCriteria.conditions.push(searchCondition);
    this.assignVehicleSearchService.setSearchCriteria(searchCriteria);
    this.assignVehicleSearchService.performSearch();
    // Subscription for the Search Events from Search Service.
    const eventSubscription = this.assignVehicleSearchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_ROW_EVENT) {
          event.selectedRow.cells[this.primaryKey].cVal = this.primarKeyValue;
          this.handleAddNewLineItem(event);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          /*** Need to be handled */
          this.assignVehicleSearchService.setNewPageEventInProgress(true);
          this.save();
        }
      });

    /*  Override the  propertyValueChanged func of DataTableEditor to catch all the valuechange calls
    so that we can modify dependent fields based on the vehicleNumber dropdwon change.
    Dependent values are present id dropdown userDefined property.
    vehicleNumber  dropdown values mapping --
     udf01: "REDEST" --> Short --> JobCode
      udf02: null --> Long --> Desc
    };
    */
    const propertyValueChangedFunc = function (event: PropertyChangeEvent): boolean {
      if (event.property === 'vehicleNumber') {
        const value = event.value;
        const dependantProp = this.dropDownKeyValueMap[value][0];
        event.row.cells['vehicleNumber'].cVal = dependantProp['vehicleNumber'];
        event.row.cells['vehicleType'].cVal = dependantProp['vehicleType'] ? dependantProp['vehicleType'] : '';
        event.row.cells['weight'].cVal = dependantProp['weight'];
        event.row.cells['volume'].cVal = dependantProp['volume'];
        event.row.cells['userDefine01'].cVal = dependantProp['userDefine01'] ? dependantProp['userDefine01'] : '';
        event.row.cells['userDefine02'].cVal = dependantProp['userDefine02'] ? dependantProp['userDefine02'] : '';
        event.row.cells['userDefine03'].cVal = dependantProp['userDefine03'] ? dependantProp['userDefine03'] : '';
        event.row.cells['userDefine04'].cVal = dependantProp['userDefine04'] ? dependantProp['userDefine04'] : '';
        event.row.cells['userDefine05'].cVal = dependantProp['userDefine05'] ? dependantProp['userDefine05'] : '';
        event.row.cells['userDefine06'].cVal = dependantProp['userDefine06'] ? dependantProp['userDefine06'] : '';
        event.row.cells['userDefine07'].cVal = dependantProp['userDefine07'] ? dependantProp['userDefine07'] : '';
        event.row.cells['userDefine08'].cVal = dependantProp['userDefine08'] ? dependantProp['userDefine08'] : '';
        event.row.cells['userDefine09'].cVal = dependantProp['userDefine09'] ? dependantProp['userDefine09'] : '';
        event.row.cells['userDefine10'].cVal = dependantProp['userDefine10'] ? dependantProp['userDefine10'] : '';
      }
      return true;
    };
    // Asiign the func and the serachservice fior use inside the function as the scope will be inside TableEditor
    this.assignVehicleSearchService.searchParams.tableEditor['propertyValueChanged'] = propertyValueChangedFunc;
    this.assignVehicleSearchService.searchParams.tableEditor['searchServiceVariable'] = this.assignVehicleSearchService;
    this.assignVehicleSearchService.searchParams.tableEditor['dropDownKeyValueMap'] = this.dropDownKeyValueMap;
  }

  /** Start:: Button Related */
  private refreshButtons() {
    this.buttonPanelButtonArray.forEach((button: ButtonItem) => {
      switch (button.action) {
        case 'Edit': {
          button.isEnabled = (this.tableMode === 'V');
          button.isVisible = (this.tableMode === 'V');
          break;
        }
        // LFWM-3191- made a new api /withPriv (replacement for setup api)
        //  to pass the privileges for checking the privileges at the backend level.
        case 'Save': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
        case 'Add Row': {
          button.isEnabled = (this.tableMode === 'E');
          button.isVisible = (this.tableMode === 'E');
          break;
        }
        // LFWM-3191- made a new api /withPriv (replacement for setup api)
        //  to pass the privileges for checking the privileges at the backend level.
        case 'Delete With Privilege': {
          button.isEnabled = true;
          button.isVisible = true;
          break;
        }
      }
    });
  }

  public handleButtonAction(action: string) {

    if (action === 'Edit') {
      this.tableMode = 'E';
      this.refreshButtons();
    } else if (action === 'Save') {
      this.save();
    } else if (action === 'Delete With Privilege') {
      this.deleteLineItem();
    }
  }

  /** end:: Button Related */


  public save() {
    const pagedRows = this.assignVehicleSearchService.getEditedRows();
    const allRows = this.assignVehicleSearchService.getAllRows();
    let savePopupPrivilege = '';
    if (allRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (pagedRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_mod'));
      this.coreServiceRegistry.navigationService.preventNavigation = false;
      this.tableMode = 'V';
      this.refreshButtons();
      return;
    }
    const finalSaveData: Array<any> = [];
    let hasValidationError: boolean = false;

    pagedRows.forEach((row: any) => {
      const rowData = [];
      const rowDataArray: any = row['cells'];
      if (row['isNewRow']) {
        if (rowDataArray['vehicleNumber'] && (rowDataArray['vehicleNumber'].cVal.trim() === '')) {
          this.alertService.clearAll().warn(this.resourceService.get('msg_veh_num_mndatry'));
          hasValidationError = true;
          return;
        }
        Object.keys(rowDataArray).forEach((element: any) => {
          if (rowDataArray[element] && (element !== 'isNewItem')) {
            const newElements: any = {
              'cName': element,
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newElements);
          } else {
            const newRowFlag: any = {
              'cName': 'isNewItem',
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newRowFlag);
          }
        });
        savePopupPrivilege = 'assgn_veh_add';
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.assignVehicleSearchService.searchParams.tableId,
          'detailItems': [],
          'privilege': savePopupPrivilege
        });
      } else {
        Object.keys(rowDataArray).forEach((element: any) => {

          const oldValue: any = {
            'cName': 'original_' + rowDataArray[element].cName,
            'cVal': rowDataArray[element].cValOrig
          };
          const newValue: any = {
            'cName': rowDataArray[element].cName,
            'cVal': rowDataArray[element].cVal
          };
          rowData.push(oldValue);
          rowData.push(newValue);
        });
        savePopupPrivilege = 'assgn_veh_edit';
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.assignVehicleSearchService.searchParams.tableId,
          'detailItems': [],
          'privilege': savePopupPrivilege
        });
      }
    });
    if (!hasValidationError) {
      this.saveDataBackendCall(finalSaveData)
      .subscribe((resp: any) => {
        if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
          if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
            // code to reload the  detail grid
            this.alertService.clearAll();
            this.alertService.success(this.resourceService.get('msg_save_succ'));
            this.coreServiceRegistry.navigationService.preventNavigation = false;
            this.tableMode = 'V';
            this.refreshButtons();
            this.assignVehicleSearchService.performSearch();
          } else {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
          }
        } else {
          if (resp.error) {
            this.alertService.clearAll();
            this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
          }
        }
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
    }
  }

  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public saveDataBackendCall(request) {
    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request))
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.status === 403) {
            return Observable.throw(error.error.message);
          } else if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
      });
    return response$;
  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteLineItem() {
    const deleteMessageError: string = 'msg_sel_detail';
    const sucessMessage: string = 'msg_del_succ';
    const confDialogMsg: string = 'msg_itm_conf_del_assgn_veh';
    let privilege = 'assgn_veh_del';
    const noOfLineItems = this.assignVehicleSearchService.getPagedData().pageDefinition.recordCount;
    const selectedRows = this.assignVehicleSearchService.getSelectedRows();
    if (noOfLineItems === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (selectedRows.length > 0) {
      const confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
      confirmDialogService.confirmDialog(this.resourceService.get(confDialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const selectedRow = this.assignVehicleSearchService.getSelectedRows();
            const finalDeleteData: Array<any> = [];

            selectedRow.forEach((row: any) => {
              const rowData = [];
              let rowDataArray: Array<any> = [];
              rowDataArray = row['cells'];
              Object.keys(rowDataArray).forEach((element: any) => {
                const item: any = {
                  'cName': rowDataArray[element].cName,
                  'cVal': rowDataArray[element].cVal
                };
                rowData.push(item);
              });

              finalDeleteData.push({
                'moduleProperties': rowData,
                'screenType': this.assignVehicleSearchService.searchParams.tableId,
                'detailItems': [],
                'privilege': privilege
              });
            });
            if (finalDeleteData.length > 0) {
              this.deleteSelectedLineItemBackendCall(finalDeleteData)
                .subscribe((resp: any) => {
                  if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
                    if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                      // code to reload the  detail grid
                      this.alertService.clearAll();
                      this.alertService.success(this.resourceService.get(sucessMessage));
                      this.assignVehicleSearchService.performSearch();
                    } else {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  } else {
                    if (resp.error) {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  }
                }, (error) => {
                  this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
                });
            }
          }
        });

    } else {
      this.alertService.clearAll();
      this.alertService.error(this.resourceService.get('msg_no_detail'));
    }
  }

  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteSelectedLineItemBackendCall(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
 /**
  * this method has the auto generation of line number logic & prepopulating loadKey
  * @param event
  */
 public handleAddNewLineItem(event) {

  this.getMaxValueForIdProperty().subscribe((response: any) => {
    if (response && response.propertyValues && response.propertyValues.length > 0) {
      const maxLineNo = response.propertyValues[0].cVal;

      const pagedData = this.assignVehicleSearchService.getPagedData();

      let lineNo = maxLineNo ? maxLineNo : '00001';
      pagedData.pageRows.forEach(row => {
        const rowLineNo = Number.parseInt(row.cells['lineNumber'].cVal);
        if (Number.parseInt(lineNo) <= rowLineNo) {
          lineNo = (rowLineNo + 1) + '';
        }
      });

      // if the current table spans across multiple pages adjust the max value
      const pageDefinition: PageDefinition = this.assignVehicleSearchService.getPagedData().pageDefinition;
      if ((pageDefinition.recordCount > pageDefinition.pageSize) && pagedData.pageRows.length === 1 ) {
        lineNo = (Number.parseInt(lineNo) + 1) + '';
      }

      let prependZeroes = 5 - lineNo.length; // ie 00001 - 5places
      let prependString = '';
      while (prependZeroes > 0) {
        prependZeroes--;
        prependString = prependString + '0';
      }

      lineNo = prependString + lineNo;

      // Autopopulate lineNo and loadkey/MbolKey for new rows
      event.selectedRow.cells['lineNumber'].cVal = lineNo;
      // get the changes reflected in aggrid UI instantly by refreshing gridApi
      pagedData.aggridApi.refreshCells({ force: true });
      // this.assignDriverSearchService.searchParams.tableEditor.refreshCells();
    }
  });

}


/**
  * Method to get the maximum value for a column in the table
  */
public getMaxValueForIdProperty() {
  const response$ = this.http$.post(`api/data/` + this.assignVehicleSearchService.searchParams.tableId + `/function`,
    {
      'functionType': 'MAX',
      'propertyNames': ['lineNumber'],
      'filterCriteria': this.assignVehicleSearchService.getSearchCriteria()
    })
    .catch((error: any) => {
      return Observable.throw('Could not fetch the max value');
    });
  return response$;
}


  @LoaderEnabled()
  public getDropdownValuesToPopulate(): Observable<any> {
    const response$ = this.http$.get(`api/wave/vehicle/dropdowns`)
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/assign-vehicle-popup/assign-vehicle-popup.component.ts